import { colors } from '@mui/material';
import { colorPalette } from '../../theme/palette';

const buildGradient = (start, end) => `linear-gradient(180deg, ${start} 0%, ${end} 100%)`;

const grey = buildGradient(colors.grey[400], colors.grey[600]);
const blue = `linear-gradient(259deg, ${colorPalette[2]}, ${colorPalette[1]})`;
const indigo = buildGradient(colors.indigo[400], colors.indigo[600]);
const green = `linear-gradient(72deg, ${colorPalette[2]}, ${colorPalette[3]})`;
const orange = buildGradient(colors.orange[400], colors.orange[700]);
const red = buildGradient(colors.red[500], colors.red[700]);

export default {
  grey,
  blue,
  indigo,
  green,
  orange,
  red
};
